<template>
  <div>
    <div class="page-title">Редактирование конфига</div>
    <base-progress-linear v-if="!init"></base-progress-linear>
    <ValidationObserver ref="observer" v-else>
      <v-card >
        <v-card-text>
          <div class="row">
            <div class="col-12">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <v-text-field
                  outlined
                  hide-details
                  label="Код конфига"
                  :error-messages="errors"
                  v-model="form.code"
                  data-cy="configCode"
                  clearable
                ></v-text-field>
              </ValidationProvider>
            </div>
            <div class="col-12">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <v-combobox
                  color="primary"
                  outlined
                  multiple
                  small-chips
                  deletable-chips
                  data-cy="configTags"
                  :items="tags.items"
                  :loading="tags.loading"
                  v-model="form.tags"
                  label="Тэги"
                  hide-details
                  :error-messages="errors">
                </v-combobox>
              </ValidationProvider>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-auto mt-3">
                  <v-btn icon dark small class="primary" @click="addSet">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
                <div class="col">
                  <v-tabs v-model="tab">
                    <template v-for="(set,i) in form.sets">
                      <v-tab  :key="i" :class="getTabClassByIndex(i)">
                        {{set.name}}
                      </v-tab>
                    </template>
                  </v-tabs>
                </div>
              </div>
              <template v-for="(set,i) in form.sets">
                <ValidationObserver ref="setValidator" :key="i">
                  <Set v-show="tab === i" :set="set"  :template="selectedTemplate"></Set>
                </ValidationObserver>
              </template>
            </div>
          </div>
        </v-card-text>
        <v-card-actions v-if="selectedTemplate">
          <v-btn class="primary"
                 @click="saveConfigWithValidation"
                 :loading="editConfig.updateLoading">Сохранить изменения</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </div>
</template>

<script>
import Set from './Add/Set.vue';
import SetModel from '../model/set';

export default {
  name: 'Edit',
  components: { Set },
  props: ['id'],
  data() {
    return {
      init: false,
      tab: null,
    };
  },
  computed: {
    templates() {
      return this.$store.state.config.templates;
    },
    tags() {
      return this.$store.state.config.tags;
    },
    editConfig() {
      return this.$store.state.config.editConfig;
    },
    form() {
      return this.editConfig.form;
    },
    selectedTemplate() {
      return this.templates.items.find(
        (template) => template.code === this.editConfig.templateCode,
      );
    },
  },
  mounted() {
    const promises = Promise.all([
      this.fetchTemplates(),
      this.fetchTags(),
      this.readConfigForEdit(this.id),
    ]);

    promises.then(() => { this.init = true; });
  },
  methods: {
    addSet() {
      this.form.sets.push(this.makeConfigSet(`set-${this.form.sets.length}`, `Набор ${this.form.sets.length}`));
    },
    makeConfigSet(code, name) {
      return new SetModel(code, name, this.selectedTemplate).toRecord();
    },
    fetchTemplates() {
      return this.$store.dispatch('config/templates');
    },
    fetchTags() {
      return this.$store.dispatch('config/tags');
    },
    readConfigForEdit(id) {
      return this.$store.dispatch('config/readConfigForEdit', id);
    },
    saveConfigWithValidation() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.sendForm();
        }
      });
    },
    sendForm() {
      this.$store.dispatch('config/updateConfig').then(() => {
        this.$router.push({ name: 'listOfConfig' });
      });
    },
    getTabClassByIndex(i) {
      const setObserver = this.$refs.setValidator && this.$refs.setValidator[i];

      let color = '';
      if (setObserver && setObserver.ctx.invalid && setObserver.ctx.validated) {
        color = 'red--text';
      }

      return color;
    },
  },
};
</script>
